const map = {
	"./ar.json": [
		1925,
		[
			1925
		]
	],
	"./bn.json": [
		4118,
		[
			4118
		]
	],
	"./de.json": [
		1873,
		[
			1873
		]
	],
	"./el.json": [
		2539,
		[
			2539
		]
	],
	"./en.json": [
		8053,
		[
			8053
		]
	],
	"./es.json": [
		1406,
		[
			1406
		]
	],
	"./fa.json": [
		6807,
		[
			6807
		]
	],
	"./fr.json": [
		7222,
		[
			7222
		]
	],
	"./hi.json": [
		9249,
		[
			9249
		]
	],
	"./id.json": [
		3999,
		[
			3999
		]
	],
	"./it.json": [
		8767,
		[
			8767
		]
	],
	"./items/en.json": [
		5596,
		[
			5596
		]
	],
	"./items/es.json": [
		5355,
		[
			5355
		]
	],
	"./items/fr.json": [
		7015,
		[
			7015
		]
	],
	"./items/zh.json": [
		2093,
		[
			2093
		]
	],
	"./ja.json": [
		7083,
		[
			7083
		]
	],
	"./ko.json": [
		3948,
		[
			3948
		]
	],
	"./languageLearning/en.json": [
		2248,
		[
			2248
		]
	],
	"./languageLearning/zh.json": [
		2825,
		[
			2825
		]
	],
	"./ms.json": [
		1702,
		[
			1702
		]
	],
	"./my.json": [
		9964,
		[
			9964
		]
	],
	"./pt.json": [
		5034,
		[
			5034
		]
	],
	"./ru.json": [
		8335,
		[
			8335
		]
	],
	"./ta.json": [
		7989,
		[
			7989
		]
	],
	"./th.json": [
		5074,
		[
			5074
		]
	],
	"./tr.json": [
		2584,
		[
			2584
		]
	],
	"./ur.json": [
		1785,
		[
			1785
		]
	],
	"./vi.json": [
		5759,
		[
			5759
		]
	],
	"./zh.json": [
		816,
		[
			816
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8631;
module.exports = webpackAsyncContext;